import { type LineCustomSvgLayer } from '@nivo/line'
import { Datum, LegendSvg } from '@nivo/legends'
import { uniqBy } from 'lodash'
import type { ReactElement } from 'react'
import { type LineChartSeries } from 'ComponentLibrary/src/molecules/Chart/types'
import { type WithBars } from './types'

export const IncomeChartLegend: LineCustomSvgLayer<LineChartSeries> = ({ points, innerWidth, innerHeight }) => {
    const legendData = uniqBy(
        points.reduce(
            (acc: Datum[], { data }) => {
                // hide empty and all-zero bars from legend
                if (!data.bars || data.bars.every(({ value }) => !value)) {
                    return acc
                }
                const bars = data.bars as WithBars<object>['bars']
                return acc.concat(
                    bars.map((bar) => ({
                        id: bar.id,
                        label: bar.id,
                        color: bar.color,
                    }))
                )
            },
            points.map(({ seriesId, seriesColor }) => ({ id: seriesId, label: seriesId, color: seriesColor }))
        ),
        'id'
    )

    const legendSpecs = {
        direction: 'row' as const,
        itemHeight: 20,
        itemWidth: 144,
        symbolShape: 'circle' as const,
        symbolSize: 10,
    }

    const legendRows: ReactElement[] = []
    for (let i = 0; i < legendData.length; i += 3) {
        const rowData = legendData.slice(i, i + 3)
        legendRows.push(
            <LegendSvg key={i} {...legendSpecs} y={innerHeight + 32 + i * 5.3} x={innerWidth / 2 - rowData.length * 72} data={rowData} />
        )
    }

    return legendRows
}
